import { default as _CheckIcon } from './icons/Check-24.svg?react'
export const CheckIcon = _CheckIcon
export type SvgIconComponent = typeof CheckIcon

export { default as PencilIcon } from './icons/Pencil-13x15.svg?react'
export { default as PlusIcon } from './icons/Plus-13x14.svg?react'
export { default as ShareIcon } from './icons/Share-16x17.svg?react'
